(function masonry($) {
    var $masonry = $('.masonry');
    if ($masonry.length === 0) {
        return;
    }

    var squizMasonry = new function()
    {
        // Checkbox filters
        var self = this;

        var $checkboxes = $('.filter__list input[type="checkbox"]'),
            selected = '',
            $showAll = $('.filter__show-all input'),

            // Masonry items
            itemClass = 'masonry__item',
            $items = $('.'+itemClass, $masonry),

            // Store cache of unloaded items
            itemUnloadedCache = [],

            // Threshold (in pixels) to start loading the masonry item
            preVisibilityThreshold = 20;

        // Get the position information for an element
        var getPositionForElem = function(elem) {
            return {
                elem: elem,
                top:  $(elem).offset().top
            };
        };

        // Fill the 'unloaded' item cache
        var fillItemCache = function() {
            itemUnloadedCache = [];
            $items.filter('.'+itemClass+'--unloaded').each(function() {
                itemUnloadedCache.push(getPositionForElem(this));
            });
        };

        // Determine if the item has come into visibility
        var isVisible = function(pos) {
            var scrollTop = window.pageYOffset;
            var viewportHeight = window.innerHeight;
            var viewportBottom = scrollTop + viewportHeight;
            return viewportBottom >= pos.top - preVisibilityThreshold;
        };

        // Load an unloaded target item by populating an image element
        var loadItem = function(target) {
            var $target = $(target);
            $target
                .removeClass(itemClass+'--unloaded')
                .find('[data-bg]')
                /*eslint no-shadow: 0, new-cap: 0*/
                .each(function(i, bgItem) {
                    var $img = $('<img src="'+$(bgItem).data('bg')+'" alt="" />');
                    $img.on('load', function() {
                        $target.addClass(itemClass+'--loaded');
                    });
                    $(bgItem).append($img);
                });
        };

        var getSelected = function() {
            return $checkboxes.filter(':checked').map(function() {
                return '.' + $(this).attr('id');
            }).toArray();
        };

        // Main fn for loading items
        var updateItems = function() {
            itemUnloadedCache.forEach(function (pos) {
                if (isVisible(pos)) {
                    loadItem(pos.elem);
                }
            });
            fillItemCache();
        };

        // Event listeners
        $(window).on('resize.masonry ready.masonry', fillItemCache);
        $(window).on('scroll.masonry', updateItems);

        // Pull previously selected filter from storage (if available)
        if (window.localStorage) {
            var stored = window.localStorage.getItem('masonry-filter');
            if (stored && stored !== '') {
                var toSet = stored.split(',');
                $checkboxes.prop('checked', false);
                $.each(toSet, function(i, item) {
                    var id = item.replace(/^./, '#');
                    $(id).prop('checked', true);
                });
                selected = stored;
            } else {
                $showAll.prop('checked', true);
                selected = '*';
            }
        } else {
            selected = getSelected().join(',');
        }

        // Basic masonry
        $masonry.isotope({
            itemSelector:    '.' + itemClass,
            layoutMode:      'masonry',
            animationEngine: 'css',

            masonry: {
                // Hardcoded width specified here to avoid CSS complexity with margins
                columnWidth: parseFloat($masonry.data('column-width')),
                gutter:      parseFloat($masonry.data('gutter'))
            },
            filter: selected,

            onLayout: function() {
                fillItemCache();
            }
        });

        // Filters
        $checkboxes.on('change', function onChange() {
            selected = getSelected().join(',');
            self.refresh(selected);

            if (window.localStorage) {
                window.localStorage.setItem('masonry-filter', selected);
            }

            if (selected.length === 0) {
                // When the clicked item is the last one, then make Show All to be checked.
                $showAll.prop('checked', true);
            } else {
                // Otherwise, uncheck Show All button.
                $showAll.prop('checked', false);
            }
        });

        $showAll.on('change', function() {
            if ($(this).is(':checked')) {
                $checkboxes.prop('checked', false);
            } else {
                $showAll.prop('checked', true);
                return;
            }

            if (window.localStorage) {
                window.localStorage.setItem('masonry-filter', '');
            }

            self.refresh();
        });

        this.refresh = function(filter)
        {
            if (filter) {
                $masonry.isotope({
                    filter: filter
                });
            } else {
                $masonry.isotope({
                    filter: '*'
                });
            }
        };

        // Case Studies Landing specific code.
        if ($('#case-study__list, #case-study__related-list').length > 0) {
            // Used for Case Studies Landing.
            var sortingMap         = [],
                sortOrdersToUpdate = {},
                layoutCallback     = null,
                movingElementInfo  = null,
                forceMoveCount     = 0;

            // Masonry grig will be sorted by sort-order property value. So, init the library with sorting option.
            $masonry.isotope({
                getSortData: {
                    sortOrder: '.case-study__item-sort-order parseInt'
                },
                sortBy: 'sortOrder',
                sortAscending: true
            });

            $masonry.isotope('on', 'layoutComplete', function(isoInstance, laidOutItems) {
                setTimeout(function() {
                    if (layoutCallback) {
                        var finished = true;
                        if (movingElementInfo) {
                            var istopeObj = $masonry.isotope('getItem', movingElementInfo.element);

                            if (movingElementInfo.initialPos.x === istopeObj.position.x
                                && movingElementInfo.initialPos.y === istopeObj.position.y
                                && forceMoveCount < 2
                            ) {
                                // Even with the new position, the element hasn't visually moved due to the grid logic.
                                // When this is detected, move one more position into the same direction. Note that
                                // this automatic move is only done twice.
                                finished = false;
                                forceMoveCount++;

                                var currentPosition = $(movingElementInfo.element).attr('data-position');
                                self.move(currentPosition, movingElementInfo.direction);
                            }
                        }

                        if (finished === true) {
                            layoutCallback.call(this, sortOrdersToUpdate);
                            layoutCallback     = null;
                            sortOrdersToUpdate = {};
                            forceMoveCount     = 0;
                            movingElementInfo  = null;
                        }
                    }//end if
                }, 100);
            });

            // Note that the order of elements in allStories might not the same as actual position on the screen.
            // So, do NOT rely on the index value of the array to set the position value. Always, get the value from
            // data-position attribute.
            var allItems    = $('#case-study__list, #case-study__related-list').find('.masonry__item'),
                allItemsLen = allItems.length,
                lastIdx     = (allItemsLen - 1),
                position    = 0,
                prevIdx     = 0,
                nextIdx     = 0;

            for (var i = 0; i < allItemsLen; i++) {
                position = parseInt($(allItems[i]).attr('data-position'), 10);
                (position === 0) ? prevIdx = lastIdx : prevIdx = (position - 1);
                (position === lastIdx) ? nextIdx = 0 : nextIdx = (position + 1);
                sortingMap.push({
                    position: position,
                    element: allItems[i],
                    prev: prevIdx,
                    next: nextIdx
                });
            }

            sortingMap.sort(function(a, b) {
                return (a.position - b.position);
            });

             var _swapStoryPosition = function(storyPos, swapPos) {
                    var storyElement       = sortingMap[storyPos].element,
                        swapElement        = sortingMap[swapPos].element,
                        storySortOrderElem = $($(storyElement).find('.case-study__item-sort-order')[0]),
                        swapSortOrderElem  = $($(swapElement).find('.case-study__item-sort-order')[0]),
                        storySortOrder     = parseInt(storySortOrderElem.html(), 10),
                        swapSortOrder      = parseInt(swapSortOrderElem.html(), 10);

                    if (swapSortOrder === storySortOrder) {
                        // If it is swapping two stories and both of them have the same sort order value, then reset the sort order
                        // values from that point to the end.
                        $(storyElement).attr('data-position', swapPos);
                        $(swapElement).attr('data-position', storyPos);

                        var tmp = sortingMap[storyPos].element;
                        sortingMap[storyPos].element = sortingMap[swapPos].element;
                        sortingMap[swapPos].element  = tmp;

                        var staringSortOrder = swapSortOrder;
                        if (storyPos > swapPos) {
                            var startingPos = swapPos;
                        } else {
                            var startingPos = storyPos;
                        }

                        var mapLen = sortingMap.length;
                        for (var i = startingPos; i < mapLen; i++) {
                            storySortOrderElem = $($(sortingMap[i].element).find('.case-study__item-sort-order')[0])
                            storySortOrderElem.html(staringSortOrder);


                            sortOrdersToUpdate[$(sortingMap[i].element).attr('data-assetid')] = staringSortOrder;
                            staringSortOrder++;
                        }
                    } else {
                        // Just swap two stories.
                        $(storyElement).attr('data-position', swapPos);
                        $(swapElement).attr('data-position', storyPos);

                        storySortOrderElem.html(swapSortOrder);
                        swapSortOrderElem.html(storySortOrder);

                        sortOrdersToUpdate[$(storyElement).attr('data-assetid')] = swapSortOrder;
                        sortOrdersToUpdate[$(swapElement).attr('data-assetid')] = storySortOrder;

                        var tmp = sortingMap[storyPos].element;
                        sortingMap[storyPos].element = sortingMap[swapPos].element;
                        sortingMap[swapPos].element  = tmp;
                    }//end if
                };

            var _moveAll = function(storyPos, direction) {
                if (direction === 'left') {
                    var settingDirection = 'prev';
                    var elementDirection = 'next';
                } else {
                    var settingDirection = 'next';
                    var elementDirection = 'prev';
                }

                var currentPos            = storyPos,
                    currentElement        = null,
                    startingSortOrderElem = $($(sortingMap[currentPos].element).find('.case-study__item-sort-order')[0]),
                    startingSortOrder     = parseInt(startingSortOrderElem.html(), 10),
                    startingPosition      = $(sortingMap[currentPos].element).attr('data-position');

                var sortOrder     = null,
                    sortOrderElem = null,
                    position      = null,
                    loopCond      = true;
                while (loopCond) {
                    if (sortingMap[currentPos][settingDirection] === storyPos) {
                        sortOrder = startingSortOrder;
                        position  = startingPosition;
                        loopCond  = false;
                    } else {
                        var nextSettingIdx  = sortingMap[currentPos][settingDirection];
                        sortOrderElem = $($(sortingMap[nextSettingIdx].element).find('.case-study__item-sort-order')[0]);
                        sortOrder     = parseInt(sortOrderElem.html(), 10);
                        position      = $(sortingMap[nextSettingIdx].element).attr('data-position');
                    }

                    $(sortingMap[currentPos].element).attr('data-position', position);
                    sortOrderElem = $($(sortingMap[currentPos].element).find('.case-study__item-sort-order')[0]);
                    sortOrderElem.html(sortOrder);

                    sortOrdersToUpdate[$(sortingMap[currentPos].element).attr('data-assetid')] = sortOrder;

                    currentPos = sortingMap[currentPos][settingDirection];
                }

                var startingElement = sortingMap[currentPos].element;
                currentPos          = storyPos;
                loopCond            = true;
                while (loopCond) {
                    if (sortingMap[currentPos][elementDirection] === storyPos) {
                        sortingMap[currentPos].element = startingElement;
                        loopCond  = false;
                    } else {
                        sortingMap[currentPos].element = sortingMap[sortingMap[currentPos][elementDirection]].element;
                    }

                    currentPos = sortingMap[currentPos][elementDirection];
                }
            };

            this.move = function(storyPos, direction, callback) {
                var isotopeObj    = $masonry.isotope('getItem', sortingMap[storyPos].element);
                movingElementInfo = {
                    element: sortingMap[storyPos].element,
                    initialPos: {
                        x: isotopeObj.position.x,
                        y: isotopeObj.position.y
                    },
                    direction: direction
                };

                if (direction === 'right') {
                    if (storyPos === lastIdx) {
                        // First story is clicked to move to the left. So, it will move every stories to the left.
                        _moveAll(storyPos, 'right');
                    } else {
                        var swapPos = sortingMap[storyPos].next;
                        _swapStoryPosition(storyPos, swapPos);
                    }
                } else if (direction === 'left') {
                    if (storyPos === 0) {
                        // First story is clicked to move to the left. So, it will move every stories to the left.
                        _moveAll(storyPos, 'left');
                    } else {
                        var swapPos = sortingMap[storyPos].prev;
                        _swapStoryPosition(storyPos, swapPos);
                    }
                }

                if (callback) {
                    layoutCallback = callback;
                }

                $masonry.isotope('updateSortData').isotope();
            };

        }//end if case-studies
    };

}(jQuery));
